import React from "react";
import SectionHeader from "../../Components/SectionHeader";
import "./index.css";

function PhotoGallery() {
    return (
        <div>
            <SectionHeader text="PREVIOUS INDUSTRY DAYS PHOTO GALLERY"></SectionHeader>
            <div className="section">
                <div className="gallery">
                    <img src="images/wiot-industry-day-2023-6.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-11.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-21.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-32.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-36.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-17.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-40.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-47.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-53.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-51.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-63.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-54.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-70.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-67.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-75.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-79.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-81.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-85.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-96.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-80.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-98.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-104.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-101.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-115.jpg" alt="id 23 event" />
                    
                    <img src="images/wiot-industry-day-2023-117.jpg" alt="id 23 event" />             
                    <img src="images/wiot-industry-day-2023-119.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-130.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-107.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2023-113.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-106.jpg" alt="id 23 event" />
                    <img src="images/wiot-industry-day-2023-132.jpg" alt="id 23 event" />      
                    <img src="images/wiot-industry-day-2023-118.jpg" alt="id 23 event" />

                    <img src="images/wiot-industry-day-2025-1320232.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320249.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320271.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320277.jpg" alt="id 25 event" />

                    <img src="images/wiot-industry-day-2025-1320302.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320384.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320413.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320461.jpg" alt="id 25 event" />

                    <img src="images/wiot-industry-day-2025-1320467.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320552.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320876.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320915.jpg" alt="id 25 event" />

                    <img src="images/wiot-industry-day-2025-1320927.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320930.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1320956.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1330041.jpg" alt="id 25 event" />

                    <img src="images/wiot-industry-day-2025-1330105.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1330189.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1330262.jpg" alt="id 25 event" />
                    <img src="images/wiot-industry-day-2025-1330322.jpg" alt="id 25 event" />
                </div>
            </div>
        </div>
    );
}

export default PhotoGallery;